export default __webpack_public_path__ + "static/logo-empowermom-b62c21b961c07124a084e5f9e6fe4073.svg";